module.exports = __webpack_public_path__ + "img/img_dashiji_wave@2x.09de29ec.png";